export const splitData = (str) => {
  const chunks = [];
  const chunkSize = 1024 * 1024; // 1 MB

  for (let i = 0; i < str.length; i += chunkSize) {
    chunks.push(str.slice(i, i + chunkSize));
  }

  return chunks;
};

export const combineData = (stringArr) => {
  let combinedData = "";
  stringArr.forEach((string) => {
    combinedData += string;
  });

  return combinedData;
};
